import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';

@Injectable({
    providedIn: 'root'
  })
  export class CustomCookieService {
    constructor(private cookieService: CookieService) {}
  
    removeAllCookiesExceptOidc(): void {
      const cookies = this.cookieService.getAll();
  
      for (const cookieName in cookies) {
        if (cookies.hasOwnProperty(cookieName) && cookieName.includes('oidc')) {
          continue;
        } else {
          this.cookieService.remove(cookieName);
        }
      }
    }
  }